import {
    CREATE_ACCESSORIES_PO_INWARD_DETAILS_REQUEST,
    CREATE_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS,
    CREATE_ACCESSORIES_PO_INWARD_DETAILS_FAILURE,
    DELETE_ACCESSORIES_PO_INWARD_DETAILS_REQUEST,
    DELETE_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS,
    DELETE_ACCESSORIES_PO_INWARD_DETAILS_FAILURE,
    FETCH_SINGLE_ACCESSORIES_PO_INWARD_DETAILS_REQUEST,
    FETCH_SINGLE_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS,
    FETCH_SINGLE_ACCESSORIES_PO_INWARD_DETAILS_FAILURE,
    FETCH_ACCESSORIES_PO_INWARD_DETAILS_REQUEST,
    FETCH_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS,
    FETCH_ACCESSORIES_PO_INWARD_DETAILS_FAILURE,
    UPDATE_ACCESSORIES_PO_INWARD_DETAILS_REQUEST,
    UPDATE_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS,
    UPDATE_ACCESSORIES_PO_INWARD_DETAILS_FAILURE,
    RESET_ACCESSORIES_PO_INWARD_DETAILS_INFO,
    CREATE_ACCESSORIES_PO_INWARD_DETAILS_FORM,
    UPDATE_ACCESSORIES_PO_INWARD_DETAILS_FORM,
    FETCH_ACCESSORIES_PO_INWARD_DETAILS_WITHOUT_ID_SUCCESS,
    ACCESSORIES_PO_INWARD_DETAILS_USERFORM_RESET,
    ACCESSORIES_PO_INWARD_DETAILS_PO_DETAILS_DISABLED,
    FETCH_ACCESSORIES_PO_PREVIOUS_LIST_REQUEST,
    FETCH_ACCESSORIES_PO_PREVIOUS_LIST_SUCCESS,
    FETCH_ACCESSORIES_PO_PREVIOUS_LIST_FAILURE,
    FETCH_ACCESSORIES_PO_DETAILS_BY_ID_REQUEST,
    FETCH_ACCESSORIES_PO_DETAILS_BY_ID_SUCCESS,
    FETCH_ACCESSORIES_PO_DETAILS_BY_ID_FAILURE,
    FETCH_ACCESSORIES_PO_INWARD_DETAILS_SO_AND_SN_SUCCESS,
    FETCH_ACCESSORIES_PO_INWARD_DETAILS_SO_AND_SN_FAILURE,
    FETCH_ACCESSORIES_PO_INWARD_DETAILS_SO_AND_SN_REQUEST,
    FETCH_PREVIOUS_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS,
    FETCH_PREVIOUS_ACCESSORIES_PO_DETAILS_SUCCESS,
    FETCH_PREVIOUS_ACCESSORIES_PO_DETAILS_FAILURE,
    FETCH_PREVIOUS_ACCESSORIES_PO_DETAILS_REQUEST,
    FETCH_PREVIOUS_ACCESSORIES_PO_INWARD_DETAILS_FAILURE,
    FETCH_PREVIOUS_ACCESSORIES_PO_INWARD_DETAILS_REQUEST,
    CREATE_USER_FORM_ACCESSORIES_PO_INWARD_GENERATE_QTY
} from './accessoriesPoInwardDetails.actionsType';

export const ACCESSORIES_PO_INWARD_DETAILS = 'accessoriesPoInwardDetails';

let initialState = {
    loading: false,
    accessoriesPoInwardDetails: [],
    accessoriesPoInwardDetailsWithoutId: [],

    accessoriesPoInwardDetailsForm: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0
    },
    previousGetList: [],
    SOAndSNGetList: [],
    selectedState: {},
    errorMessage: '',
    isPoDetailsDisabled: false
};

export let accessoriesPoInwardDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ACCESSORIES_PO_INWARD_DETAILS_REQUEST:
             return {
                ...state,
                loading: true,
                accessoriesPoInwardDetails: []
            };
        case CREATE_ACCESSORIES_PO_INWARD_DETAILS_REQUEST:
        case UPDATE_ACCESSORIES_PO_INWARD_DETAILS_REQUEST:
        case FETCH_SINGLE_ACCESSORIES_PO_INWARD_DETAILS_REQUEST:
        case DELETE_ACCESSORIES_PO_INWARD_DETAILS_REQUEST:
        case FETCH_ACCESSORIES_PO_PREVIOUS_LIST_REQUEST:
             return {
        ...state,
        loading: true,
        previousGetList: [],
        selectedRows: []
    };
        case FETCH_ACCESSORIES_PO_INWARD_DETAILS_SO_AND_SN_REQUEST:
        case FETCH_PREVIOUS_ACCESSORIES_PO_INWARD_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: true,
                accessoriesPoInwardDetails: updatePayload
            };
        case FETCH_ACCESSORIES_PO_INWARD_DETAILS_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: true,
                accessoriesPoInwardDetailsWithoutId: updatePayload
            };
        case CREATE_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,

                accessoriesPoInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0
                },
                isPoDetailsDisabled: false
            };
        case UPDATE_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedState: {},
                accessoriesPoInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldIGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0
                },
                isPoDetailsDisabled: false
            };
        case FETCH_SINGLE_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedState: updatePayload,
                accessoriesPoInwardDetailsForm: { ...updatePayload }
            };
            {
                /*case FETCH_PREVIOUS_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload
            };*/
            }
        case DELETE_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesPoInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0
                },
                selectedState: {},
                isPoDetailsDisabled: false
            };
        case RESET_ACCESSORIES_PO_INWARD_DETAILS_INFO:
            return {
                ...state,
                accessoriesPoInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldDiscountPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0
                }
            };
        case CREATE_ACCESSORIES_PO_INWARD_DETAILS_FORM:
        case UPDATE_ACCESSORIES_PO_INWARD_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                accessoriesPoInwardDetailsForm: {
                    ...state.accessoriesPoInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };

        case FETCH_PREVIOUS_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload
            };
        case FETCH_ACCESSORIES_PO_INWARD_DETAILS_SO_AND_SN_SUCCESS:
            return {
                ...state,
                loading: false,
                SOAndSNGetList: updatePayload
            };
        case CREATE_USER_FORM_ACCESSORIES_PO_INWARD_GENERATE_QTY:
            return {
                ...state,
                loading: false,
           //     editAccessoriesInwardList: payload
                editAccessoriesInwardList: payload.map((row) => ({
            ...row,
            FldQuantity: row.FldQuantity
        }))
            };
        case FETCH_ACCESSORIES_PO_INWARD_DETAILS_FAILURE:
        case CREATE_ACCESSORIES_PO_INWARD_DETAILS_FAILURE:
        case UPDATE_ACCESSORIES_PO_INWARD_DETAILS_FAILURE:
        case FETCH_SINGLE_ACCESSORIES_PO_INWARD_DETAILS_FAILURE:
        case DELETE_ACCESSORIES_PO_INWARD_DETAILS_FAILURE:
        case FETCH_ACCESSORIES_PO_PREVIOUS_LIST_FAILURE:
        case FETCH_ACCESSORIES_PO_INWARD_DETAILS_SO_AND_SN_FAILURE:
        case FETCH_PREVIOUS_ACCESSORIES_PO_INWARD_DETAILS_FAILURE:
            return {
                ...state,
                loading: false
            };
        case ACCESSORIES_PO_INWARD_DETAILS_USERFORM_RESET:
            return {
                ...state,
                accessoriesPoInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldDiscountPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0
                },
                selectedState: {},
                isPoDetailsDisabled: false
            };
        case ACCESSORIES_PO_INWARD_DETAILS_PO_DETAILS_DISABLED:
            return {
                ...state,
                isPoDetailsDisabled: payload
            };
        default:
            return state;
    }
};
